export enum TableViewTypeInfluencerEnum {
  INFLUENCERS_VIEW = 'influencersView',
  CHRONIQUEUR_VIEW = 'chroniqueurView',
  NEW_CHRONIQUEUR_VIEW = 'newChroniqueurView',
}
